import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { SourceSystemRepository } from '@front/repository/Api/SourceSystem';
import type { ISourceSystemRepository } from '@front/repository/Api/SourceSystem/interface';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sourceSystemQueryKeys } from './queryKeys';

const repository = new SourceSystemRepository();

export const _update = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: ISourceSystemRepository.Update.Params) => {
      return repository.update(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION) });
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: sourceSystemQueryKeys.list(variables.projectId) });
      void queryClient.invalidateQueries({
        queryKey: sourceSystemQueryKeys.detail(variables.projectId, variables.id),
      });
    },
    ...UseMutationDefaultOptions,
  });
};
